import React, { useState } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { SheetMusicLibrary } from '../SheetMusicLibrary';
import { ChevronLeftIcon, MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { TeacherSidebar } from '../TeacherSidebar';
import { useTheme } from '../providers/ThemeProvider';
export const SheetMusicPage = () => {
  const location = useLocation();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  // Add state for sidebar toggle (matching other dashboard pages)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // Toggle sidebar on mobile
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Determine if user is a teacher or student based on the URL path
  const isTeacher = location.pathname.includes('teacher');
  const returnPath = isTeacher ? '/teacher-dashboard' : '/student-dashboard';
  return <div className={`w-full min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white' : 'bg-gradient-to-r from-gray-50 to-gray-100 text-gray-800'} font-sans transition-colors duration-300`} data-id="element-4911">
      <Navbar data-id="element-4912" />
      <div className="pt-20 pb-16 flex flex-col lg:flex-row" data-id="element-4913">
        {/* Mobile sidebar toggle - matching other dashboard pages */}
        <button onClick={toggleSidebar} className="lg:hidden fixed bottom-4 right-4 z-30 bg-deep-pink text-white p-3 rounded-full shadow-lg" data-id="element-4914">
          {isSidebarOpen ? <XIcon data-id="element-4915" /> : <MenuIcon data-id="element-4916" />}
        </button>
        {/* Left Sidebar - for teacher view only */}
        {isTeacher && <aside className={`w-64 fixed inset-y-0 pt-20 pb-16 ${isDark ? 'bg-navy-900/90 shadow-lg' : 'bg-white shadow-md'} z-20 transform transition-all duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`} data-id="element-4917">
            <TeacherSidebar darkMode={isDark} data-id="element-4918" />
          </aside>}
        {/* Main Content - adjusted margin for sidebar */}
        <main className={`flex-1 transition-all duration-300 ease-in-out ${isTeacher ? isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-64' : ''} px-4 py-6`} data-id="element-4919">
          <div className="max-w-7xl mx-auto" data-id="element-4920">
            <div className="flex items-center mb-6" data-id="element-4921">
              <Link to={returnPath} className={`inline-flex items-center mr-4 ${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-4922">
                <ChevronLeftIcon className="h-5 w-5 mr-1" data-id="element-4923" />
                <span data-id="element-4924">Back to Dashboard</span>
              </Link>
              <h1 className={`text-2xl font-serif font-bold ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4925">
                Sheet Music Library
              </h1>
            </div>
            <SheetMusicLibrary darkMode={isDark} data-id="element-4926" />
          </div>
        </main>
      </div>
      <Footer data-id="element-4927" />
    </div>;
};